import React from 'react';
import './css/login.css';
import $ from 'jquery';
import { auth } from './firebase';
import { Link } from 'react-router-dom';
const INITIAL_STATE = {
  email: '',
  password: '',
  error: null,
};

const updateByPropertyName = (propertyName, value) => () => ({
  [propertyName]: value,
});
export default class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = (event) => {
    const {
      email,
      password,
    } = this.state;

    const {
      history,
    } = this.props;

    auth.doSignInWithEmailAndPassword(email, password)
      .then(() => {
        this.setState(() => ({ ...INITIAL_STATE }));
        history.push("/");
      })
      .catch(error => {
        this.setState(updateByPropertyName('error', error));
      });

    event.preventDefault();
  }

  componentDidMount() {
    $("body").addClass("login");
    $("body").removeClass("m-page--wide m-header--fixed m-header--fixed-mobile m-footer--push m-aside--offcanvas-default");
  }
  render() {
    const {
      email,
      password,
      error,
    } = this.state;

    const isInvalid =
      password === '' ||
      email === '';

    return (
      <div>
        <div className="logo">
          <Link to="/">
            <img src="../images/logo-white.png" alt="" /> </Link>
        </div>
        <div className="content">
          <form className="login-form d-block" onSubmit={this.onSubmit} >

            <h3 className="form-title font-blue">Admin SignIn</h3>
            <div className="alert alert-danger display-hide">
              <a className="close" data-close="alert"></a>
              {error && <p>{error.message}</p>}
              <span> Enter any username and password. </span>
            </div>
            <div className="form-group">
              <label className="control-label visible-ie8 visible-ie9">Username</label>
              <input className="form-control" type="email" autoComplete="off"
                value={email}
                onChange={event => this.setState(updateByPropertyName('email', event.target.value))}
                placeholder="Username" name="username" /> </div>
            <div className="form-group">
              <label className="control-label visible-ie8 visible-ie9">Password</label>
              <input className="form-control" type="password"
                onChange={event => this.setState(updateByPropertyName('password', event.target.value))}
                type="password"
                autoComplete="off" placeholder="Password" name="password" /> </div>
            <div className="form-group">
              <label className="rememberme check mt-checkbox mt-checkbox-outline">
              </label>
              <br />
              <button type="submit" className="btn btn-primary" disabled={isInvalid}>Login</button>
            </div>
            <div className="create-account">
              <p>
                <a href="javascript:;" id="forget-password" className="uppercase">Forget Password?</a>
              </p>
            </div>
          </form>
          <form className="forget-form d-none" action="index.html" method="post">

            <h3 className="form-title">Forget Password ?</h3>
            <p> Enter your e-mail address below to reset your password. </p>
            <div className="form-group">
              <input className="form-control placeholder-no-fix" type="text" autoComplete="off" placeholder="Email" name="email" /> </div>
            <div className="form-actions">
              <button type="button" id="back-btn" className="btn green btn-outline">Back</button>
              <button type="submit" className="btn btn-primary uppercase pull-right">Submit</button>
            </div>
          </form>
        </div >
        <div className="copyright"> 2018 &copy; UffRide Admin Dashboard. </div>
      </div>
    );
  }
}
/**/


// WEBPACK FOOTER //
// ./src/Login.js